<template>
  <div>
    <div>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.ALI.computeInstance.InstanceStatus") }}:
          </span>
          <span class="expand-value">{{ row.stateName }}</span>
        </Col>

        <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.ALI.computeInstance.PrivateIP") }}:
          </span>
          <span class="expand-value">{{ row.privateIp }}</span>
        </Col>
      </Row>
      <Row class="expand-row">
       <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.ALI.computeInstance.InstanceCreatedTime") }}:
          </span>
          <span class="expand-value">{{ row.instanceCreatedTime }}</span>
        </Col>

         <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.GCP.computeInstance.project") }}:
          </span>
          <span class="expand-value">{{ row.project }}</span>
        </Col>
      </Row>
      <Row class="expand-row">
       <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.GCP.computeInstance.owner") }}:
          </span>
          <span class="expand-value">{{ row.owner }}</span>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    row: Object,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.expand-row {
  padding-left: 17px;
  margin-bottom: 10px;
}
.expand-key {
  width: 145px;
  display: block;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/hwc/obs/TableExpand.vue